<template>
    <h1 class="title-logo">Корзина</h1>
    <div v-if="loading == true" class="cart">
        <div class="cart-item skeleton">
            <div class="cart-item__header">
                <div class="cart-item__category"></div>
                <div class="cart-item__remove"></div>
            </div>
            <div class="cart-item__content catalog">
                <div class="catalog-item">
                    <div class="catalog-item__title"></div>
                    <div class="catalog-item__count"></div>
                </div>
                <div class="catalog-item">
                    <div class="catalog-item__title"></div>
                    <div class="catalog-item__count"></div>
                </div>
            </div>
            <div class="cart-item__submit-btn primary-btn wide-btn"></div>
        </div>
    </div>
    <div v-else class="cart">
        <div v-if="items.length <= 0" class="empty-par">
            <svg class="svg-icon-cart2 svg-icon" width="60" height="50">
                <use xlink:href="#cart2"></use>
            </svg>
            <p>Корзина пуста. <br>Добавьте товары в корзину из каталога.</p>
            <router-link class="primary-btn" to="/catalog">
                <svg class="svg-icon-catalog svg-icon" width="25" height="25">
                    <use xlink:href="#catalog"></use>
                </svg>
                Каталог
            </router-link>
        </div>
        <form  v-for="item in items" class="cart-item" action="/">
            <div class="cart-item__header">
                <a class="cart-item__category" href="javascript:;">{{item.group_name}}</a>
                <a @click="deleteGroup(item.group_id)" class="cart-item__remove" href="javascript:;">
                    <svg class="svg-icon-close svg-icon" width="12" height="12">
                        <use xlink:href="#close"></use>
                    </svg>
                    <!-- Удалить -->
                </a>
            </div>
            <div class="cart-item__content catalog">
                <div v-for="position in item.positions" class="catalog-item">
                    <div class="catalog-item__title">{{position.product}} ({{position.unit}})</div>
                    <div class="catalog-item__count count">
                        <button class="count__btn" type="button">&ndash;</button>
                        <input class="count__input" type="text" :value="position.count">
                        <button class="count__btn" type="button">+</button>
                    </div>
                </div>
            </div>
            <button @click="orderGroup(item.group_id)" class="cart-item__submit-btn primary-btn wide-btn" type="button">Оформить</button>
        </form>

        <div class="modal modal--msg micromodal-slide" :class="{'is-open':openAuth}" id="modal-no-auth" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close="">
                <div class="modal__container" role="dialog" aria-modal="true">
                    <div class="modal__title"></div>
                    <div class="modal__inner">
                        <div class="modal__area">
                            <div class="modal__success">
                                <div class="modal__msg-title">Необходима авторизация</div>
                                <div class="modal__msg-text">Для заказа вам необходимо пройти авторизацию</div>
                            </div>
                        </div>
                        <div class="modal__btns modal__btns--no-margin">
                            <button @click="openAuth = false" class="modal__btn btn secondary-btn round-btn" type="button">Закрыть</button>
                            <button @click="toAuth" class="modal__btn btn secondary-btn round-btn" type="button">Авторизация</button>
                        </div>
                    </div>
                    <!--<button class="modal__btn modal__close btn" @click="" data-micromodal-close>
                        <svg class="svg-icon--close svg-icon" width="15" height="15">
                            <use xlink:href="#close"></use>
                        </svg>
                    </button>-->
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import IMask from 'imask';

    export default {

        name: 'Basket',

        data: function(){
            return {
                loading:true,
                isLoadData:false,
                openAuth:false,
                items: [],
            };
        },

        created() {
            this.$root.scrollable = false;
            this.$root.pageClass = "";
        },

        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
        },

        mounted:function () {

            let self = this;

            self.loading = true;
            self.isLoadData = false;

            let time = 100;

            let interval = setInterval(function () {
                if(time <= 0 && self.isLoadData){
                    self.loading = false;
                    clearInterval(interval);
                } else{
                    time = time - 100;
                }
            },100);

            self.$root.instance.get(
                '/basket/list',
            ).then(function (response) {
                if(response.data.status == 'error'){
                    let errors = '';
                    response.data.errors.forEach(function (item) {
                        errors += item.message
                    });
                    alert(JSON.stringify(errors));
                }else{

                    if(response.data.items != null)
                        self.items = response.data.items;

                    self.isLoadData = true;

                    setTimeout(function () {
                        window.initModules();
                    }, 500);
                }
            });
        },

        components: {},

        methods: {
            deleteGroup: function(groupId){
                alert("delete group " + groupId)
            },
            toAuth: function(){
                this.$router.push('/auth');
            },
            orderGroup: function(groupId){
                if(this.user.id > 0){
                    this.$router.push('/order_create/' + groupId);
                }else{
                    this.openAuth = true;
                }
            }
        }
    }
</script>
